// extracted by mini-css-extract-plugin
module.exports = {"opening":"retailer_opening__rvyB3","wrapper":"retailer_wrapper__a0gLx","title":"retailer_title__00jlr","hoursRow":"retailer_hoursRow__KLnAG","phone":"retailer_phone__QlWgV"};